import { render, staticRenderFns } from "./DataTableLiberacoes.vue?vue&type=template&id=1fce0906&scoped=true&"
import script from "./DataTableLiberacoes.vue?vue&type=script&lang=js&"
export * from "./DataTableLiberacoes.vue?vue&type=script&lang=js&"
import style0 from "./DataTableLiberacoes.vue?vue&type=style&index=0&id=1fce0906&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fce0906",
  null
  
)

export default component.exports